// The refinement list that is toggled dynamically from the HierarchicalRefinementList
// On desktop, it is shown on hover, on touch devices it is shown on touch
// On mobile, it doesn't flyout but replaces the filter in the filter slideout

import React from "react";
import PropTypes from "prop-types";

import { RefinementList } from "components/search/base/RefinementList";
import IconButton from "components/shared/IconButton";
import flyoutReference from "components/search/references/flyoutReference";

const propTypes = {
  attribute: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  hidden: PropTypes.bool,
  hideFlyout: PropTypes.func.isRequired,
  hideFlyoutHover: PropTypes.func.isRequired,
  refine: PropTypes.func.isRequired
};

const defaultProps = {
  hidden: true
};

const Flyout = (props) => {
  const categories =
    flyoutReference[flyoutReference.referenceMapping[props.category]];
  let className = "refinement-list__flyout";
  if (props.hidden) className += " hidden";

  let title = props.category;
  if (["Lit Guide", "Poetry Guide", "Lit Term"].indexOf(title) > -1) {
    title = `${title}s`;
  }

  return (
    <div className={className} onMouseLeave={props.hideFlyoutHover}>
      <div className="refinement-list__flyout-header">
        <IconButton
          btnClass="btn-sm btn-text"
          iconClass="lc-icon-arrow-left lc-icon-xs"
          onClick={props.hideFlyout}
          text="All filters"
        />
        <h2>{props.category}</h2>
      </div>
      <RefinementList
        attribute={props.attribute}
        categories={categories}
        controlled
        currentRefinement={props.currentRefinement}
        items={props.items}
        refine={props.refine}
      />
    </div>
  );
};

Flyout.propTypes = propTypes;
Flyout.defaultProps = defaultProps;

export default Flyout;
